<template>
  <div id="navbar" class="sticky-top" style="z-index:100">
    <div
      class="shadow-holder w-100 position-absolute shadow-lg"
      style="bottom:0px;height:50%"
    ></div>
    <nav class="navbar navbar-expand-md bg-white p-0">
      <div class="nav-wrapper w-100">
        <b-container>
          <b-row align-v="center" align-h="between" class="py-2 py-md-2">
            <b-col col class="desktop-menus d-none d-md-block ">
             
            </b-col>

            <b-col cols="1" class="mobile-menu-button d-block d-md-none w-100 pl-3">
              
              <button class="btn float-left pl-0 " @click="toggleMobileMenu(true)">
                <i class="fas fa-bars" style="color:#fff; font-size:20px"></i>
              </button>

            </b-col>
            <div class="lft" style="font-size:20px; color:#fff; margin-left: 15px"><img src="@/assets/icons/logo-dark.svg" height="45" /></div>
            <b-col class="d-md-none text-right"></b-col>
          </b-row>
        </b-container>
      </div>
    </nav>
    <!-- <ToolBar /> -->
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
// import ToolBar from "./ToolBar";

export default {
  name: "navbar",
  components: {
    // ToolBar
  },
  methods: {
    ...mapActions("ui", ["toggleDarkMode", "toggleMobileMenu"])
  },
  computed: {
    ...mapState("ui", ["mobileMenuSwitch"]),
    ...mapState(["userObj"]),
    ...mapGetters("ui", ["getThemeMode"]),
    setMenu() {
      return [
        { name: "Dashboard", link: "/dashboard", icon: "ti-home" },
        { name: "Investments", link: "/investments", icon: "ti-bar-chart" },
        { name: "Wallet", link: "/wallet", icon: "ti-wallet" },
        { name: "Slots Purchased", link: "/slots", icon: "ti-ticket" },
        { name: "Referrals", link: "/referrals", icon: "ti-cup" }
      ];
    }
  }
};
</script>

<style lang="scss">

.navbar {
  background-color: #6FAF24 !important
}

#navbar {
  overflow: hidden;
  .nav-item:nth-child(1) a.nav-link {
    // padding-left: 0 !important;
  }

  .ion {
    font-size: 22px;
  }
}

.lft {
  float:left;
}

.rgt {
  float:right;
}

.clr {
  clear:both
}

.shadow-holder {
  // box-shadow: 1px 0px 20px rgba(0, 0, 0, 0.08);
}

.nav-item a {
  color: rgba(0, 0, 0, 0.6);
}

.nav-item > a.router-link-active {
  color: var(--primary) !important;
  background-color: #ffffff;
  border-radius: 4px;
  // box-shadow: 1px 0px 20px rgba(0, 0, 0, 0.08);
  // border-bottom: 3px solid #85c341;
}

//Change the navarbar link sizes on tablets
/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  #navbar {
    // border-bottom: 5px solid var(--secondary);
    .desktop-menus {
      font-size: 0.75rem;
    }
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  #navbar {
    .desktop-menus {
      font-size: 0.9rem;
    }
  }
}

.ripple-icon {
  border-radius: 100%;
  animation: ripple 0.6s linear infinite;
}

.activate-account-button {
  overflow: hidden;
  border: none !important;
  padding: 0.5em 1em;
}
</style>
